import React, { useContext, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import { Store } from './Provider';
import SelectCities from '../../../../../components/FormInputs/SelectCities';
import FleetsTextFields from 'components/TextFields/FleetsTextFields';
import PriceWithLabel from '../../../../../components/TextFields/PriceWithLabel';
import toEN from '../../../../../fns/toEn';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import { Button } from '@material-ui/core';
import Select from 'react-select';
import { useCalculation } from 'useStores/useCalculation';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7,1fr)',
    gridGap: theme.spacing(1),
  },
}));

const Form = () => {
  const classes = useStyles();
  const location = useLocation();
  const isEditing = useMemo(() => !!location.state, [location.state]);
  const editingItems = location.state ? JSON.parse(location.state) : null;
  const {
    state: {
      inProgress,
      date,
      origin,
      destination,
      fleetOptions,
      basePrice,
      page,
      legalLoad,
    },
    dispatch,
    actions: { fetch, save, loadList },
  } = useContext(Store);

  let error = false;
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 10,
    }),
    control: (provided, state) => ({
      ...provided,
      height: 56,
      width: '100%',
      border: `1px solid ${error ? 'red' : '#ccc'}`,
    }),
  };

  const legalOptions = [
    { label: 'تجاری', value: 'legal' },
    { label: 'غیرتجاری', value: 'notLegal' },
  ];
  const handleChagneDate = (date) => {
    dispatch({ type: 'DATE', payload: date });
  };
  const handleChangeOrigin = (city) => {
    dispatch({ type: 'CHANGE_ORIGIN', payload: city });
  };
  const handleChangeDestination = (city) => {
    dispatch({ type: 'CHANGE_DESTINATION', payload: city });
  };
  const handleLegalLoad = (option) => {
    const legalLoads = option?.map((item) => item.value);
    dispatch({ type: 'CHANGE_LEGAL_LOAD', payload: legalLoads });
  };
  const handleChangeFleetOptions = (fleetOptions) => {
    dispatch({ type: 'CHANGE_FLEETOPTIONS', payload: fleetOptions });
  };
  const handleChangeBasePrice = (e) => {
    let { value } = e.target;
    value = toEN(value);
    dispatch({ type: 'BASE_PRICE', payload: value });
  };
  const handleSubmit = async () => {
    save();
  };
  useEffect(() => {
    if (origin && destination && date && fleetOptions?.length) {
      fetch();
    }
  }, [origin, destination, date, fleetOptions]);
  useEffect(() => {
    // if (isEditing) {
    //   dispatch({ type: 'CHANGE_LEGAL_LOAD', payload: editingItems.cargoType });
    // }
    loadList();
  }, [origin, destination, date, fleetOptions, page, legalLoad]);

  useEffect(() => {
    if (isEditing) {
      dispatch({ type: 'DATE', payload: editingItems.date });
      dispatch({ type: 'CHANGE_ORIGIN', payload: editingItems.origin });
      dispatch({
        type: 'CHANGE_DESTINATION',
        payload: editingItems.destination,
      });
      dispatch({
        type: 'CHANGE_FLEETOPTIONS',
        payload: editingItems.fleetOptions,
      });
    }
  }, [isEditing]);

  return (
    <div className={classes.root}>
      <DatePicker size="large" value={date} onChange={handleChagneDate} />
      <SelectCities
        isMulti={false}
        placeholder="شهر مبدا"
        city={origin}
        isDest={false}
        onSelect={handleChangeOrigin}
        hasLabel
      />
      <FleetsTextFields
        single
        onChange={handleChangeFleetOptions}
        selection={fleetOptions}
        title="نوع ناوگان"
      />
      <SelectCities
        isMulti={false}
        placeholder="شهر مقصد"
        city={destination}
        onSelect={handleChangeDestination}
        hasLabel
      />
      <Select
        defaultValue={legalOptions[0]}
        options={legalOptions}
        styles={customStyles}
        isMulti
        placeholder={'ماهیت بار'}
        onChange={(option) => handleLegalLoad(option)}
        value={legalOptions.filter((option) =>
          legalLoad?.includes(option?.value)
        )}
      />
      <PriceWithLabel
        onChange={handleChangeBasePrice}
        value={basePrice || ''}
        label="کرایه"
        position="down"
        onKeyPress={(e) => {
          e.key === 'Enter' && handleSubmit();
        }}
      />
      <Button
        endIcon={<BookmarkIcon />}
        variant="contained"
        color="primary"
        disabled={inProgress}
        onClick={handleSubmit}
        className="mb-1"
      >
        ذخیره
      </Button>
    </div>
  );
};

export default React.memo(Form);
